import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { Reveal } from "@/components/motion/Reveal";
import { CutImage } from "@/components/site/Shared";

const POINTS = [
  "Family-run, with over 20 years in the motor trade",
  `AutoTrader Highly Rated for customer service — ${DEALER.awards.join(", ")}`,
  "Free Gold cover warranty with most vehicles",
  "Live video viewings on FaceTime or WhatsApp",
];

export const Welcome = () => (
  <section className="bg-paper py-16 lg:py-28" aria-labelledby="welcome-heading" data-testid="welcome-section">
    <div className="container-x grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
      <Reveal className="lg:col-span-6">
        <CutImage
          src="/stock/202608185206801/00.webp"
          alt="Land Rover Freelander 2 on the YK Motors forecourt in Peterborough"
          className="aspect-[4/3] w-full"
        />
      </Reveal>
      <Reveal className="lg:col-span-6" delay={0.1}>
        <p className="eyebrow">Welcome to YK Motors</p>
        <h2 id="welcome-heading" className="mt-4 font-display text-3xl font-extrabold leading-[1.04] tracking-tight sm:text-4xl lg:text-[2.75rem]">
          A family-run dealership with a personal approach.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-steel md:text-lg">
          We're an independent used car dealer in Peterborough. We privately source our cars, and every one is quality checked by our staff
          and qualified mechanics before it's advertised.
        </p>
        <p className="mt-4 text-base leading-relaxed text-steel">
          We're open seven days a week. Viewings are by appointment, and we're happy to fit around your working hours.
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2">
          {POINTS.map((p) => (
            <li key={p} className="flex gap-3 rounded-md border border-line bg-white p-4 text-sm font-medium leading-snug text-ink">
              <span className="mt-0.5 inline-block h-4 w-1.5 shrink-0 -skew-x-[32deg] bg-brand" aria-hidden="true" />
              {p}
            </li>
          ))}
        </ul>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link to="/about" className="btn btn-dark" data-testid="welcome-about-button">
            More about us <ArrowRight className="arrow" aria-hidden="true" />
          </Link>
          <a href={DEALER.phone.href} className="btn btn-outline" data-testid="welcome-call-link">
            <Phone aria-hidden="true" /> {DEALER.phone.display}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
